import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Table,
  Input,
  InputNumber,
  Select,
  Form,
  Tooltip,
  Col,
  Spin,
  Radio,
  Modal,
  Row,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import SiteSelectionModal from "./SiteSelectionModal";
import { Collapse } from "antd";
import { getRequest, postRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { useNavigate } from "react-router-dom";
import PurchaseRequisitionSites from "./PurchaseRequisitionSites";

const { Panel } = Collapse;

const NewPR = (selectedCategoryId) => {

  const [siteName, setSiteName] = useState([]);
  const navigate = useNavigate();
  const { Option } = Select;
  const [pincodeList, setPincodeList] = useState([]);
  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoading2, setBtnLoading2] = useState(false);
  const [view, setView] = useState("");
  const [userSelectedSiteList, setUserSelectedSiteList] = useState([]);
  const [siteModal, setSiteModal] = useState(false);
    const [reload, setReload] = useState(false);

  const { t } = useTranslation();
  const { id, prId } = useParams();
  const formRef = useRef();

  const [estimatedValueFromApi, setEstimatedValueFromApi] = useState([
    {
      id: "",
      value: "",
    },
  ]);
  const [totalAmountPr, setTotalAmountPr] = useState(0);
  const [disabled, setDisabled] = useState(true);
  const [tableData, setTableData] = useState([]);

  const [stateWBS, setStateWBS] = useState([]);

  const initialState = {
    company: CompanyID,
    category_tree: id,
    total_amount: null,
    purchase_requisition_details: [],
  };
  const [state, setState] = useState([]);
  const [filterData, setFilterData] = useState([]);

  const [siteWiseTotalAmount, setSiteWiseTotalAmount] = useState({
    siteName: "",
    total: "",
  });

  const [siteTotalQuantities, setSiteTotalQuantities] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [cityLength, setCityLength] = useState(1);
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [apiLoading, setapiLoading] = useState(false);
  const [viewOption, setViewOption] = useState(false);
  const [prView, setPRView] = useState(null);

  const [overallTotal, setOverallTotal] = useState(0);

  const getSubCategory = async () => {
    setapiLoading(true);

    try {
      let apiResponse;
      if (prId === null || prId === undefined) {
        apiResponse = await getRequest(
          `company-material-code/1/get-pr-material-by-city/`
        );
      }
      else {
        apiResponse = await getRequest(
          `purchase-requisition/${prId}/`
        );
      }

      if (apiResponse.data.success) {
        setState(apiResponse.data.data);
        setPRView(apiResponse?.data?.data?.pr_type);
        const prType = apiResponse.data.data.pr_type || 'City Wise';
        setView(prType);
        formRef.current.setFieldsValue({
          pr_view: prType
        });
      }

      if (apiResponse.data.data) {
        const purchaseRequisitionDetails = apiResponse.data.data.map((item) => {
          // const siteWise = siteName.map((site) => ({
          //   site_name: site.id,
          //   quantity: null, // Set the initial quantity to null or whatever default value you need
          // }));
          // return {
          //   material_type: item.id,
          //   unit_of_measurement: 1,
          //   total_quantity: 0,
          //   site_wise: siteWise,
          // };
        });
        setState((prevState) => ({
          ...prevState,
          purchase_requisition_details: purchaseRequisitionDetails,
        }));
        const uniqueSubCategories = Array.from(
          new Set(apiResponse.data.data.map((item) => item.sub_category))
        );

        setSubCategoryList(uniqueSubCategories);
        setSubCategoryData(apiResponse.data.data);
        setapiLoading(false);

      } else {
        ErrorNotificationMsg(t("error_in_company_adress_list"));
      }
      setapiLoading(false);
    } catch (error) {
      setapiLoading(false);
    }
  };

    useEffect(() => {
      //console.log("load here")
    }, [reload]);

  useEffect(() => {
    getSubCategory();
    getCurrency();
    getUnitOfMeasurement();
    if (siteName.length === 0) {
      getSiteName();
    }
    if (userSelectedSiteList.length === 0) {
        setSiteModal(true);
    }
  }, [id, prId]);

    const filterParentDataBySites = (parentData, comparisonData) => {
        const siteIds = new Set(comparisonData.map(site => site.id));

        return parentData
            .map(city => {
                const filteredSites = city.site_wise_details.filter(site => siteIds.has(site.site_id));
                return filteredSites.length > 0 ? { ...city, site_wise_details: filteredSites } : null;
            })
            .filter(city => city !== null);
    };
    const updateFilteredData = () => {
        const filteredData = filterParentDataBySites(state.city_wise_pr, userSelectedSiteList);

        setState(prevState => {
            if (JSON.stringify(prevState.city_wise_pr) !== JSON.stringify(filteredData)) {
                return { ...prevState, city_wise_pr: filteredData };
            }
            return prevState; // Return previous state if data hasn't changed
        });
    };

    useEffect(() => {
        if (userSelectedSiteList.length > 0) {
            updateFilteredData();
        }
    }, [userSelectedSiteList]); // Only run when userSelectedSiteList or city_wise_pr changes


    let updateTableData = [];
  let updateWbsData = [];

  if (prId === null || prId === undefined) {
      //console.log("userSelectedSiteList in New PR", userSelectedSiteList);
      const updatedState = { ...state };
      //console.log("userSelectedSiteList in New PR", updatedState);
      // if (Object.keys(updatedState).length !== 0 && userSelectedSiteList.length !== 0) {
      //
      //
      //     const filterParentDataBySites = (parentData, comparisonData) => {
      //         // Create a Set of site IDs from comparison data for efficient lookup
      //         const siteIds = new Set(comparisonData.map(site => site.id));
      //
      //         // Filter parentData based on site IDs
      //         return parentData
      //             .map(city => {
      //                 // Filter sites within each city
      //                 const filteredSites = city.site_wise_details.filter(site => siteIds.has(site.site_id));
      //
      //                 // Return updated city only if it has matching sites
      //                 return filteredSites.length > 0 ? { ...city, site_wise_details: filteredSites } : null;
      //             })
      //             .filter(city => city !== null); // Remove cities with no matching sites
      //     };
      //
      //     const filteredData = filterParentDataBySites(updatedState.city_wise_pr, userSelectedSiteList);
      //     console.log(filteredData);
      //     console.log("state0001", state);
      // }
    updateTableData = (state) => {
      setapiLoading(true);
      const tableData = [];
      const length = state?.city_wise_pr?.length;
      setCityLength(length);

      state?.city_wise_pr?.forEach((city, cityIndex) => {
        console.log('city001', city);
        
        const cityRowSpan = 2;

        let cityTotalQuantity = 0;
        let cityTotalQuantityForKG = 0;
        let cityTotalAmountForKG = 0;
        let cityTotal = 0;
        city.site_wise_details.forEach((site, siteIndex) => {
          console.log('site600 ', site);
          
          let siteTotalQuantity = 0;
          let siteTotalQuantityForKG = 0;
          let siteTotalAmountForKG = 0;
          let siteMaterialTotal = 0;

          site.material_wise_details?.forEach((material) => {
           // material.material_remark = null;
            siteTotalQuantity += material.material_type_quantity;
            siteMaterialTotal += material.material_type_quantity * material.estimated_material_unit_price;
                let quantityInKG = 0;
                if (material.material_type_uom_name === "MT") {
                    siteTotalQuantityForKG += material.material_type_quantity * 1000 || 0;
                    quantityInKG = material.material_type_quantity * 1000 || 0;
                } else if (material.material_type_uom_name === "Bag") {
                    siteTotalQuantityForKG += material.material_type_quantity * 50 || 0;
                    quantityInKG = material.material_type_quantity * 50 || 0;
                } else {
                    siteTotalQuantityForKG += material.material_type_quantity || 0;
                    quantityInKG = material.material_type_quantity || 0;
                }
                //siteTotalAmountForKG += siteTotalQuantityForKG * material.estimated_material_unit_price;
                // Calculate amount for this material based on quantityInKG
                const amountForMaterial = quantityInKG * material.estimated_material_unit_price;
                siteTotalAmountForKG += amountForMaterial;
           // siteTotalQuantityForKG += material.material_type_quantity
          });
          site.site_total_quantity = siteTotalQuantity;
          site.site_total_quantity_kg = siteTotalQuantityForKG;
          site.site_total_amount_kg = siteTotalAmountForKG;

          setSiteTotalQuantities((prevQuantities) => [
            ...prevQuantities,
            siteTotalQuantity,
          ]);

          cityTotalQuantity += siteTotalQuantity;
            cityTotalQuantityForKG += siteTotalQuantityForKG;
            cityTotalAmountForKG += siteTotalAmountForKG;
          cityTotal += siteMaterialTotal;
           // console.log(site.material_wise_details);
          tableData.push({
            key: `${cityIndex}-${siteIndex}`,
            srNo:
              length > 1
                ? siteIndex === 0
                  ? cityIndex + 1
                  : null
                : siteIndex + 1,
            cityName: siteIndex === 0 ? city.city_name : null,
            cityRowSpan: siteIndex === 0 ? cityRowSpan : 0,
            siteName: site.site_name,
            siteLocations: site.material_wise_details?.map((material, matIndex) => ({
                availableBudget: material.available_budget || 0,
                estimatedPRValue: material.estimated_pr_value || 0,
                materialName: material.material_type_name,
                remark: material.material_remark,
                quantity: material.material_type_quantity,
                uom: material.material_type_uom,
                material_type_uom_name: material.material_type_uom_name,
                subCategory: material.material_type_sub_category,
                siteIndex,
                matIndex,
                cityId: city.city_id,
                siteId: site.site_id,
                estimatedPrice: material.estimated_material_unit_price
              })
            ),
            totalAmount: (
              <Input
                disabled
                className="site-subtotal"
              />
            ),
          });
          tableData.push({
            key: `${cityIndex}-${siteIndex}-SiteSubTotal`,
            siteName: `Sub Total for ${site.site_name} site`,
            siteName1: "Site Sub Total",
            siteLocations: [
              {
                totalQuantity: siteMaterialTotal,
                totalQuantityByKG: siteTotalQuantityForKG,
                totalAmountByKG: siteTotalAmountForKG,
                materialName: "",
                quantity: siteTotalQuantity,
                subCategory: "",
                siteIndex,
                matIndex: 0,
                cityId: city.city_id,
                siteId: site.site_id,
              },
            ],
            totalAmount: (
              <Input
                disabled
                value={`\u20B9 ${siteTotalQuantity || 0}`}
                className="site-subtotal"
              />
            ),
            siteTotalQuantity: (
              <Input
                disabled
                value={siteTotalQuantity || 0}
                className="site-total-quantity"
                readOnly
              />
            ),
          });
          if (length > 1) {
            if (siteIndex === city.site_wise_details.length - 1) {
              tableData.push({
                key: `${cityIndex}-${siteIndex}-CityTotal`,
                siteName: `City Total - ${city.city_name} `,
                siteName1: "City Total",
                siteLocations: [
                  {
                    materialName: "",
                    cityTotal: cityTotal,
                    quantity: cityTotalQuantity,
                    cityQuantityForKG: cityTotalQuantityForKG,
                    cityTotalAmountForKG: cityTotalAmountForKG,
                    subCategory: "",
                    siteIndex,
                    matIndex: 0,
                    cityId: city.city_id,
                    siteId: site.site_id,
                  },
                ],
                totalAmount: (
                  <Input
                    disabled
                    value={`\u20B9 ${cityTotalQuantity || 0}`}
                    className="subtotal"
                    readOnly
                  />
                ),
                cityTotalQuantity: (
                  <Input
                    disabled
                    value={cityTotalQuantity || 0}
                    className="city-total-quantity"
                    readOnly
                  />
                ),
              });
            }
          }
        });

        city.city_total_quantity = cityTotal;
      });
      setTableData(tableData);
      setapiLoading(false);

    };


    updateWbsData = (state) => {
      const tableData = [];
      const length = state?.city_wise_pr?.length;
      setCityLength(length);

      let overallTotal = 0;
      let overallQuantity = 0;
        let overAllSiteTotalAmountForKG = 0;

      state?.city_wise_pr?.forEach((city, cityIndex) => {
        let cityTotalQuantity = 0;
        let cityTotal = 0;
        let cityTotalAmountForKg = 0;

        city.site_wise_details.forEach((site, siteIndex) => {
          let siteTotalQuantity = 0;
          let siteMaterialTotal = 0;
          let siteTotalQuantityForKG = 0;
          let siteTotalAmountForKG = 0;

          site.material_wise_details?.forEach((material) => {
            siteTotalQuantity += material.material_type_quantity;
            siteMaterialTotal += material.material_type_quantity * material.estimated_material_unit_price;
                let quantityInKG = 0;
                if (material.material_type_uom_name === "MT") {
                    siteTotalQuantityForKG += material.material_type_quantity * 1000 || 0;
                    quantityInKG = material.material_type_quantity * 1000 || 0;
                } else if (material.material_type_uom_name === "Bag") {
                    siteTotalQuantityForKG += material.material_type_quantity * 50 || 0;
                    quantityInKG = material.material_type_quantity * 50 || 0;
                } else {
                    siteTotalQuantityForKG += material.material_type_quantity || 0;
                    quantityInKG = material.material_type_quantity || 0;
                }
                // Calculate amount for this material based on quantityInKG
                const amountForMaterial = quantityInKG * material.estimated_material_unit_price;
                siteTotalAmountForKG += amountForMaterial;
          });
          cityTotalQuantity += siteTotalQuantity;
          cityTotal += siteMaterialTotal;
          cityTotalAmountForKg += siteTotalAmountForKG;

          tableData.push({
            srNo: length > 1 ? siteIndex === 0 ? cityIndex + 1 : null : siteIndex + 1,
            cityName: siteIndex === 0 ? city.city_name : null,
            key: `${cityIndex}-${siteIndex}`,
            siteName: site.site_name,
            siteLocations: site.material_wise_details?.map(
              (material, matIndex) => ({
                availableBudget: material.available_budget || 0,
                estimatedPRValue: siteMaterialTotal || 0,
                cityId: city.city_id,
                siteId: site.site_id,
                matIndex,
              })
            ),
          });
        });
        if (length > 1) {
          tableData.push({
            key: `${cityIndex}-CityTotal`,
            siteName: "City Total",
            siteLocations: [
              {
                cityTotal: cityTotal,
              },
            ],
            totalAmount: (
              <Input
                disabled
                value={`\u20B9 ${cityTotal || 0}`}
                className="subtotal"
                readOnly
              />
            ),
          });
        }

        overallTotal += cityTotal;
        overallQuantity += cityTotalQuantity;
        overAllSiteTotalAmountForKG += cityTotalAmountForKg;
      });
      //console.log("overAllSiteTotalAmountForKG", overAllSiteTotalAmountForKG);
      const formattedOverallTotal = parseFloat(overAllSiteTotalAmountForKG.toFixed(0));
      setOverallTotal(formattedOverallTotal);
      tableData.push({
        key: "OverallTotal",
        siteName: "Total",
        siteLocations: [
          {
            cityTotal: overallTotal,
          },
        ],
        totalAmount: (
          <Input
            disabled
            value={`\u20B9 ${overallTotal || 0}`}
            className="citysubtotal"
            readOnly
          />
        ),
      });

      setStateWBS(tableData);
    };
  }
  else {
    updateTableData = (state) => {
      setapiLoading(true);
      const tableData = [];
      const length = state?.city_wise_pr?.length;

      setCityLength(length);

      state?.city_wise_pr?.forEach((city, cityIndex) => {

        const cityRowSpan = city.site_wise_pr.length;
        let cityTotalQuantity = 0;
        let cityTotal = 0;

        city.site_wise_pr.forEach((site, siteIndex) => {
          let siteTotalQuantity = 0;
          let siteMaterialTotal = 0;
          site.site_total_quantity += siteTotalQuantity;

          site.pr_material_details?.forEach((material) => {

            //material.material_remark = null;
            siteTotalQuantity += material.pr_material_type_quantity;
            siteMaterialTotal +=
              material.pr_material_type_quantity * 105;
          });
          site.site_total_quantity = siteTotalQuantity;

          setSiteTotalQuantities((prevQuantities) => [
            ...prevQuantities,
            siteTotalQuantity,
          ]);

          cityTotalQuantity += siteTotalQuantity;
          cityTotal += siteMaterialTotal;
           //console.log(site.pr_material_details);
          tableData.push({
            key: `${cityIndex}-${siteIndex}`,
            srNo:
              length > 1
                ? siteIndex === 0
                  ? cityIndex + 1
                  : null
                : siteIndex + 1,
            cityName: siteIndex === 0 ? city.city_name : null,
            cityRowSpan: siteIndex === 0 ? cityRowSpan : 0,
            siteName: site.pr_site_name,
            siteLocations: site.pr_material_details?.map(
              (material, matIndex) => ({
                availableBudget: material.available_budget || 0,
                estimatedPRValue: 185 || 0,
                materialName: material.pr_material_type_name,
                remark: material.material_remark,
                quantity: material.pr_material_type_quantity,
                uom: material.pr_material_type_uom,
                subCategory: material.pr_material_type_sub_category,
                siteIndex,
                matIndex,
                cityId: city.city_name,
                siteId: site.pr_site_id,
                estimatedPrice: material.estimated_material_unit_price,
              })
            ),
            totalAmount: (
              <Input
                disabled
                className="site-subtotal"
              />
            ),
          });
          tableData.push({
            key: `${cityIndex}-${siteIndex}-SiteSubTotal`,
            siteName: "Site Sub Total",
            siteLocations: [
              {
                totalQuantity: siteMaterialTotal,
                materialName: "",
                quantity: siteTotalQuantity,
                subCategory: "",
                siteIndex,
                matIndex: 0,
                cityId: city.city_id,
                siteId: site.site_id,
              },
            ],
            totalAmount: (
              <Input
                disabled
                value={`\u20B9 ${siteTotalQuantity || 0}`}
                className="site-subtotal"
              />
            ),
            siteTotalQuantity: (
              <Input
                disabled
                value={siteTotalQuantity || 0}
                className="site-total-quantity"
                readOnly
              />
            ),
          });
          if (length > 1) {
            if (siteIndex === city.site_wise_pr.length - 1) {
              tableData.push({
                key: `${cityIndex}-${siteIndex}-CityTotal`,
                siteName: "City Total",
                siteLocations: [
                  {
                    materialName: "",
                    cityTotal: cityTotal,
                    quantity: cityTotalQuantity,
                    subCategory: "",
                    siteIndex,
                    matIndex: 0,
                    cityId: city.city_id,
                    siteId: site.site_id,
                  },
                ],
                totalAmount: (
                  <Input
                    disabled
                    value={`\u20B9 ${cityTotalQuantity || 0}`}
                    className="subtotal"
                    readOnly
                  />
                ),
                cityTotalQuantity: (
                  <Input
                    disabled
                    value={city.city_total_quantity || 0}
                    className="city-total-quantity"
                    readOnly
                  />
                ),
              });
            }
          }
        });

        city.city_total_quantity = cityTotal;
      });
      setTableData(tableData);
      setapiLoading(false);

    };


    updateWbsData = (state) => {
      const tableData = [];
      const length = state?.city_wise_pr?.length;
      setCityLength(length);

      let overallTotal = 0;
      let overallQuantity = 0;

      state?.city_wise_pr?.forEach((city, cityIndex) => {
        let cityTotalQuantity = 0;
        let cityTotal = 0;

        city.site_wise_pr.forEach((site, siteIndex) => {
          let siteTotalQuantity = 0;
          let siteMaterialTotal = 0;

          site.pr_material_details?.forEach((material) => {
            siteTotalQuantity += material.pr_material_type_quantity;
            siteMaterialTotal +=
              material.pr_material_type_quantity *
              material.estimated_material_unit_price;
          });

          cityTotalQuantity += siteTotalQuantity;
          cityTotal += siteMaterialTotal;

          tableData.push({
            srNo:
              length > 1
                ? siteIndex === 0
                  ? cityIndex + 1
                  : null
                : siteIndex + 1,
            cityName: siteIndex === 0 ? city.city_name : null,
            key: `${cityIndex}-${siteIndex}`,
            siteName: site.pr_site_name,
            siteLocations: site.pr_material_details?.map(
              (material, matIndex) => ({
                availableBudget: material.available_budget || 0,
                estimatedPRValue: siteMaterialTotal || 0,
                cityId: city.city_id,
                siteId: site.site_id,
                matIndex,
              })
            ),
          });
        });
        if (length > 1) {
          tableData.push({
            key: `${cityIndex}-CityTotal`,
            siteName: "City Total",
            siteLocations: [
              {
                cityTotal: cityTotal,
              },
            ],
            totalAmount: (
              <Input
                disabled
                value={`\u20B9 ${cityTotal || 0}`}
                className="subtotal"
                readOnly
              />
            ),
          });
        }

        overallTotal += cityTotal;
        overallQuantity += cityTotalQuantity;
      });

      setOverallTotal(overallTotal);


      tableData.push({
        key: "OverallTotal",
        siteName: "Total",
        siteLocations: [
          {
            cityTotal: overallTotal,
          },
        ],
        totalAmount: (
          <Input
            disabled
            value={`\u20B9 ${overallTotal || 0}`}
            className="citysubtotal"
            readOnly
          />
        ),
      });

      setStateWBS(tableData);
    };
  }


  useEffect(() => {
    setapiLoading(true);
    updateTableData(state);
    updateWbsData(state);
    setapiLoading(false);
  }, [state]);

    const handleOk = () => {
        setSiteModal(false);
    };
    const handleSave = (data) => {
      ///console.log("data", data);
         setSiteName(data);
        setUserSelectedSiteList(data);
        setSiteModal(false);

    };
    const handleCancel = () => {
        setSiteModal(false);
    };
  const getUnitOfMeasurement = async (data) => {
    setapiLoading(true);
    await getRequest("get-category-by-uom/?category_tree", data).then(
      (response) => {
        const filteredData = response.data.results.data.filter(
          (item) => item.unit_of_measurement !== "KG"
        );
        setPincodeList(filteredData);
      }
    );
    setapiLoading(false);
  };

  const getSiteName = async () => {
    try {
      let apiResponse = await getRequest(
        `delivery-address/${CompanyID}/address-by-company/`
      );
      if (apiResponse.data.data) {
        //console.log("11111111", apiResponse.data.data);
        setSiteName(apiResponse.data.data);
        const updatedState = { ...state };
        updatedState.purchase_requisition_details.forEach((detail) => {
          detail.site_wise.forEach((site, index) => {
            site.site_name = apiResponse.data.data[index]
              ? apiResponse.data.data[index].site.id
              : null;
          });
        });
        ///console.log("updatedState", updatedState);
        setState(updatedState);
      } else {
        ErrorNotificationMsg(t("error_in_company_adress_list"));
      }
      //setLoading(false);
    } catch (error) {
      //setLoading(false);
    }
  };
  const subCategoryColumnsWBC = [
    {
      title: "WBS",
      dataIndex: "WBS",
      key: "WBS",
      render: (text, record, rowIndex) => <span>{stateWBS[rowIndex]}</span>,
    },
  ];

  const WBCsiteNameColumns = siteName.map((item, index) => ({
    title: item.site_name,
    dataIndex: `site_name_${index}`,
    key: `site_name_${index}`,
    render: (text, record, rowIndex) => (
      <>
        <Input
          addonBefore={currencySymbol}
          style={{ width: "100%" }}
          value={rowIndex ? siteWiseTotalAmount[item.id] : ""}
          readOnly
        />
      </>
    ),
    width: 170,
  }));

  const handleRemarkChange = (e, cityId, siteId, matIndex) => {
       const { value } = e.target;
      if (prId) {
          setState((prevState) => {
              const newState = { ...prevState };
              newState.city_wise_pr = newState.city_wise_pr.map((city) => {
                  if (city.city_name === cityId) {
                      city.site_wise_pr = city.site_wise_pr.map((site, siteIndex) => {
                          if (site.pr_site_id === siteId) {
                              console.log(site.pr_material_details[matIndex].pr_material_type_quantity);
                              site.pr_material_details[matIndex].material_remark = value || 0;
                          }
                          return site;
                      });
                  }
                  return city;
              });
              return newState;
          });
      }
      else {
          setState((prevState) => {
              const newState = { ...prevState };
              newState.city_wise_pr = newState.city_wise_pr.map((city) => {
                  if (city.city_id === cityId) {
                      city.site_wise_details = city.site_wise_details.map((site, siteIndex) => {
                          if (site.site_id === siteId) {
                              site.material_wise_details[matIndex].material_remark = value;
                          }
                          return site;
                      });
                  }
                  return city;
              });
              return newState;
          });
      }
  };
  const handleInputChange = (e, cityId, siteId, matIndex) => {
    const { value } = e.target;
    if (prId) {
      setState((prevState) => {
        const newState = { ...prevState };
        newState.city_wise_pr = newState.city_wise_pr.map((city) => {
          if (city.city_name === cityId) {
            city.site_wise_pr = city.site_wise_pr.map((site, siteIndex) => {
              if (site.pr_site_id === siteId) {
                site.pr_material_details[matIndex].pr_material_type_quantity = parseFloat(value) || 0;
              }
              return site;
            });
          }
          return city;
        });
        return newState;
      });
    }
    else {
      setState((prevState) => {
        const newState = { ...prevState };
        newState.city_wise_pr = newState.city_wise_pr.map((city) => {
          if (city.city_id === cityId) {
            city.site_wise_details = city.site_wise_details.map((site, siteIndex) => {
              if (site.site_id === siteId) {
                site.material_wise_details[matIndex].material_type_quantity = parseFloat(value) || 0;
                //site.material_wise_details[matIndex].material_total_quantity_by_kg = site.site_total_quantity_kg || 0;
                  if (site.material_wise_details[matIndex].material_type_uom_name === "MT") {
                      site.material_wise_details[matIndex].material_total_quantity_by_kg = value * 1000 || 0;
                  } else if (site.material_wise_details[matIndex].material_type_uom_name === "Bag") {
                      site.material_wise_details[matIndex].material_total_quantity_by_kg = value * 50 || 0;
                  } else {
                      site.material_wise_details[matIndex].material_total_quantity_by_kg = value || 0;
                  }
              }
              return site;
            });
          }
          return city;
        });
        return newState;
      });
    }


  };


  const handleUOMChange = (value, cityId, siteId, matIndex, unitOfMeasurement) => {

    if (prId) {
      setState((prevState) => {
        const newState = { ...prevState };
        newState.city_wise_pr = newState.city_wise_pr.map((city) => {
          if (city.city_name === cityId) {
            city.site_wise_pr = city.site_wise_pr.map((site, siteIndex) => {
              if (site.pr_site_id === siteId) {
                //console.log("UOMChange",site.pr_material_details[matIndex]);
                site.pr_material_details[matIndex].pr_material_type_uom = value;
              }
              return site;
            });
          }
          return city;
        });
        return newState;
      });
    }
    else {
      setState((prevState) => {
        const newState = { ...prevState };
        newState.city_wise_pr = newState.city_wise_pr.map((city) => {
          if (city.city_id === cityId) {
            city.site_wise_details = city.site_wise_details.map((site, siteIndex) => {
              if (site.site_id === siteId) {
                site.material_wise_details[matIndex].material_type_uom = value;
                site.material_wise_details[matIndex].material_type_uom_name = unitOfMeasurement;
                  if (unitOfMeasurement === "MT") {
                      site.material_wise_details[matIndex].material_total_quantity_by_kg = site.material_wise_details[matIndex].material_type_quantity * 1000 || 0;
                  } else if (unitOfMeasurement === "Bag") {
                      site.material_wise_details[matIndex].material_total_quantity_by_kg = site.material_wise_details[matIndex].material_type_quantity * 50 || 0;
                  } else {
                      site.material_wise_details[matIndex].material_total_quantity_by_kg = site.material_wise_details[matIndex].material_type_quantity || 0;
                  }

              }
              return site;
            });
          }
          return city;
        });
        return newState;
      });
    }
  };
  const filterItemsBySubCategory = (subCategory) => {
    return subCategoryData.filter((item) => item.sub_category === subCategory);
  };

  const getCurrency = async (data) => {
    await getRequest(
      "business-settings/get-currency-by-business-setting/",
      data
    ).then((response) => {
      setCurrencySymbol(response.data.data);
    });
  };
 
  const wbsBudget = [
    {
      title: "SR.",
      dataIndex: "srNo",
      fixed: "left",
      width: 70,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      fixed: "left",
      width: 150,
      render: (text) => <div className="lblvalue">{text}</div>,
    },
    {
      title: "Available Budget",
      dataIndex: "siteLocations",
      width: 200,
      render: (siteLocations, record) => {
        if (record.siteName !== "City Total" && record.siteName !== "Total") {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginRight: "20px",
              }}
            >
              <div key={1} className="lblvalue">
                <Input
                  addonBefore={currencySymbol}
                  type="number"
                  min={0}
                  style={{ width: "100%" }}
                  readOnly
                  value={1000000}
                />
              </div>
            </div>
          );
        }
        return null;
      },
    },
    {
      title: "Estimated PR Value",
      dataIndex: "siteLocations",
      render: (siteLocations, record) => {
        if (record.siteName === "City Total" || record.siteName === "Total") {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginRight: "20px",
              }}
            >
              <div className="lblvalue">
                <Input
                  addonBefore={currencySymbol}
                  type="number"
                  min={0}
                  style={{ width: "20%" }}
                  value={siteLocations[0].cityTotal}
                  readOnly
                />
              </div>
            </div>
          );
        } else {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginRight: "20px",
              }}
            >
              <div key={1} className="lblvalue">
                <Input
                  addonBefore={currencySymbol}
                  type="number"
                  min={0}
                  style={{ width: "20%" }}
                  value={siteLocations[0].estimatedPRValue}
                  readOnly
                />
              </div>
            </div>
          );
        }
      },
    },
  ];

  if (cityLength > 1) {
    wbsBudget.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 150,
      render: (text) => <div className="lblvalue">{text}</div>,
    });
  }

  const theadWbsBudget = <Table columns={wbsBudget} />;

  const columns = [
    {
      title: "SR.",
      dataIndex: "srNo",
      fixed: "left",
      width: 50,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      // fixed: "left",
      width: 220,
    },
    {
      title: "Item",
      dataIndex: "siteLocations",
      // fixed: "left",
      width: 120,
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div key={index} className="lblvalue">
                {site.materialName}
              </div>
            ))}
          </div>
        </>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "siteLocations",
      width: 140,
      render: (siteLocations, record) => {
        console.log("Record Quantity", record)
        if (record.siteName1 === "Site Sub Total") {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginRight: "20px",
                }}
              >
                {siteLocations.map((site, index) => (
                  <div key={index} className="lblvalue">
                    {/* <Input
                      // disabled
                      readOnly
                      type="number"
                      min={0}
                      style={{ width: "100%" }}
                      value={site.quantity}
                      rules={t("val_name")}
                    /> */}
                    
                  </div>
                ))}
              </div>
            </>
          );
        } 
        else if (record.siteName1 === "City Total") {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginRight: "20px",
                }}
              >
                {siteLocations.map((site, index) => (
                  <div key={index} className="lblvalue">
                    {/* <Input
                      readOnly
                      type="number"
                      min={0}
                      style={{ width: "100%" }}
                      value={site.quantity}
                    /> */}
                  </div>
                ))}
              </div>
            </>
          );
        } else {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginRight: "20px",
                }}
              >
                {siteLocations.map((site, index) => (
                  <div key={index} className="lblvalue">
                    <Input
                      type="text"
                      min={0}
                      maxLength={5}
                      style={{ width: "100%" }}
                      // value={site.quantity}
                      value={site.quantity || ""}
                      placeholder="Enter Qty"
                      onChange={(e) =>
                        handleInputChange(
                          e,
                          site.cityId,
                          site.siteId,
                          site.matIndex
                        )
                      }
                    />
                  </div>
                ))}
              </div>
            </>
          );
        }
      },
    },
    {
      title: (
        <Tooltip
            color="#094E8F"
            placement="top"
            title={<span style={{ color: "#fff" }}>Preferred Unit of measurement means Your company buys material generally in this unit of measurement</span>}
        >
            Preferred UoM.
        </Tooltip>
    ),
       
      width: 120,
      dataIndex: "siteLocations",
      render: (siteLocations, record) => {
        const defaultOption = pincodeList.find(
          (option) => option.unit_of_measurement === "MT"
        );
        const defaultValue = defaultOption ? defaultOption.id : 1;
        if (
          record.siteName1 === "City Total" ||
          record.siteName1 === "Site Sub Total"
        ) {
          return "";
        }
        return (
          <>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {siteLocations.map((site, index) => (
                <div key={index}>
                  <Select
                    style={{ width: "100%" }}
                    defaultValue={1}
                    onChange={(value) => {
                        const selectedOption = pincodeList.find(option => option.id === value);
                        handleUOMChange(value, site.cityId, site.siteId, site.matIndex, selectedOption.unit_of_measurement);
                    }}
                    // onChange={(value) =>
                    //   handleUOMChange(
                    //     value,
                    //     site.cityId,
                    //     site.siteId,
                    //     site.matIndex
                    //   )
                    // }
                  >
                    {pincodeList.map((option) => (
                      <Option key={option.id} value={option.id}>
                        {option.unit_of_measurement}
                      </Option>
                    ))}
                  </Select>
                </div>
              ))}
            </div>
          </>
        );
      },
    },
      {
          title: (
            <Tooltip
                color="#094E8F"
                placement="top"
                title={<span style={{ color: "#fff" }}>Quantity In KG</span>}
            >
                Qty. In KG
            </Tooltip>
        ),
          dataIndex: "siteLocations",
          width: 120,
          align:'right',
          render: (siteLocations, record) => {
              console.log("recordKilogram", record);
              return (
                  <>
                  <div
                      style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                          alignItems: 'flex-end'
                      }}
                  >
                      {siteLocations.map((site, index) => {
                          let total = 0;
                          if (site.material_type_uom_name === "MT") {
                              total = site.quantity * 1000 || 0;
                          } else if (site.material_type_uom_name === "Bag") {
                              total = site.quantity * 50 || 0;
                          } else {
                              total = site.quantity || 0;
                          }
                          if (site.materialName !== "") {
                              return (
                                  <div key={index} className="lblvalue" style={{padding: '5px'}}>
                                      {total ? total.toLocaleString('en-IN', { maximumFractionDigits: 0 }) : 0}
                                  </div>
                              );
                          } else if (record.siteName1 === "City Total") {
                              return (
                                  <div key={index} className="lblvalue" style={{padding: '5px'}}>
                                      {site.cityQuantityForKG.toLocaleString('en-IN', { maximumFractionDigits: 0 })}
                                  </div>
                              );
                          } else {
                              return (
                                  <div key={index} className="lblvalue" style={{padding: '5px'}}>
                                      {site.totalQuantityByKG ? site.totalQuantityByKG.toLocaleString('en-IN', { maximumFractionDigits: 0 }) : 0}
                                  </div>
                              );
                          }
                      })}
                  </div>
                  </>
              );
          },
      },
    {
      title: (
        <Tooltip
            color="#094E8F"
            placement="top"
            title={<span style={{ color: "#fff" }}>Estimated Amount</span>}
        >
            Est. Amount
        </Tooltip>
    ), 
      
      dataIndex: "siteLocations",
      width: 120,
      align:'right',
      render: (siteLocations, record) => {
        return (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                alignItems: 'flex-end'
              }}
            >
              {siteLocations.map((site, index) => {
                //let total = site.quantity * site.estimatedPrice;
                  let total = 0;
                  if (site.material_type_uom_name === "MT") {
                      total = site.quantity * 1000 || 0;
                  } else if (site.material_type_uom_name === "Bag") {
                      total = site.quantity * 50 || 0;
                  } else {
                      total = site.quantity || 0;
                  }
                if (site.materialName !== "") {
                  return (
                    <div key={index} className="lblvalue" style={{marginTop:'5px'}}>
                      {/* <InputNumber
                          addonBefore={currencySymbol}
                          min={0}
                          style={{ width: "100%" }}
                          formatter={(value) =>
                              `${new Intl.NumberFormat('en-IN').format(value)}`
                          }
                          parser={(value) => value.replace(/[^0-9.]/g, '')}
                          value={total ? total * (site?.estimatedPrice || 0) : ""}
                          readOnly
                      /> */}

                      ₹ {total ? (total * (site?.estimatedPrice || 0))?.toLocaleString('en-IN', { maximumFractionDigits: 0 }) : 0}
                    </div>
                  );
                } else if (record.siteName1 === "City Total") {
                  return (
                    <div key={index} className="lblvalue" style={{marginTop:'5px'}}>
                      {/* <InputNumber
                          addonBefore={currencySymbol}
                          min={0}
                          style={{ width: "100%" }}
                          formatter={(value) =>
                              `${new Intl.NumberFormat('en-IN').format(value)}`
                          }
                          parser={(value) => value.replace(/[^0-9.]/g, '')}
                          value={site.cityTotalAmountForKG ? site.cityTotalAmountForKG : ""}
                          readOnly
                      /> */}

                      ₹ {site.cityTotalAmountForKG ? site.cityTotalAmountForKG?.toLocaleString('en-IN', { maximumFractionDigits: 0 }) : 0}
                    </div>
                  );
                } else {
                  return (
                    <div key={index} className="lblvalue" style={{marginTop:'5px'}}>
                      {/* <InputNumber
                          addonBefore={currencySymbol}
                          min={0}
                          style={{ width: "100%" }}
                          formatter={(value) =>
                              `${new Intl.NumberFormat('en-IN').format(value)}`
                          }
                          parser={(value) => value.replace(/[^0-9.]/g, '')}
                          value={site.totalAmountByKG ? site.totalAmountByKG?.toLocaleString('en-IN', { maximumFractionDigits: 0 }) : ""}
                          readOnly
                      /> */}
                      ₹ {
                        site.totalAmountByKG ? site.totalAmountByKG?.toLocaleString('en-IN', { maximumFractionDigits: 0 }) : 0
                      }
                    </div>
                  );
                }
              })}
            </div>
          </>
        );
      },
    },
    {
          title: "Remarks",
          dataIndex: "siteLocations",
          // fixed: "left",
          // width: 150,
          render: (siteLocations, record) => {
              if (record.siteName1 !== "Site Sub Total" && record.siteName1 !== "City Total") {
                  return(
                      <>
                      <div
                          style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "10px",
                              marginRight: "20px",
                          }}
                      >
                          {siteLocations.map((site, index) => (
                              <div key={index} className="lblvalue">
                                <Input
                                    type="text"
                                    style={{ width: "180px" }}
                                    value={site.remark}
                                    placeholder="Enter Remarks"
                                    onChange={(e) => handleRemarkChange(e, site.cityId, site.siteId, site.matIndex)}
                                />
                              </div>
                          ))}
                      </div>
                      </>
                  );
              }
          },
      },
  ];

  if (cityLength > 1) {
    columns.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 130,
      render: (text, record, index) => {
        if (index === 0 || record.cityName !== tableData[index - 1].cityName) {
          return <div className="lblvalue">{text}</div>;
        } else {
          return <div className="lblvalue" />;
        }
      },
    });
  }

  const theadPR = <Table columns={columns} />;

  const subCategoryTables = subCategoryList.map((subCategory, index) => {
    const subCategoryItems = filterItemsBySubCategory(subCategory);
    const subCategoryColumns = [
      {
        title: index + 1,
        dataIndex: "Sr No",
        key: "1",
        width: 80,
        render: (text, record, ind) => {
          return `${index + 1}.${ind + 1}`;
        },
      },
      {
        title: subCategory,
        dataIndex: "type_name", 
        key: "type_name",
      },
      ...(index === 0
        ? siteName.map((site, index) => ({
          title: site.site_name, 
          dataIndex: `site_name_${index}`, 
          key: `${site.site_name}_${subCategory}_${index}`, 
          width: 170,
          render: (text, record) => (
            <Input
              type="number"
              min={0}
              style={{ width: "100%" }}
              value={record[`quantity_${index}`]} 
              onChange={(e) => handleInputChange(e, record.id, index)} 
            />
          ),
        }))
        : siteName.map((site, index) => ({
          key: `${site.site_name}_${subCategory}_${index}`, 
          width: 170,
          render: (text, record) => (
            <Input
              type="number"
              min={0}
              style={{ width: "100%" }}
              value={record[`quantity_${index}`]} 
              onChange={(e) => handleInputChange(e, record.id, index)} 
            />
          ),
        }))),
      {
        title: index === 0 ? "Total Quantity" : "",
        dataIndex: "total_quantity",
        key: "total_quantity",
        width: 150,
        render: (text, record) => {
          const correspondingRecord = state.purchase_requisition_details.find(
            (item) => item.material_type === record.id
          );

          const totalQuantity = correspondingRecord
            ? correspondingRecord.total_quantity || ""
            : 0;

          return (
            <Input
              type="number"
              min={0}
              disabled
              style={{ width: "100%" }}
              value={totalQuantity}
            />
          );
        },
      },
      {
        title: index === 0 ? "UOM." : "",
        dataIndex: "unit_of_measurement",
        key: "unit_of_measurement",
        width: 150,
        render: (text, record, rowIndex) => {
          const defaultOption = pincodeList.find(
            (option) => option.unit_of_measurement === "MT"
          );
          const defaultValue = defaultOption ? defaultOption.id : 1;
          return (
            <Select
              style={{ width: "100%" }}
              defaultValue={defaultValue}
              onChange={(value) => handleUOMChange(value, record.id)}
            >
              {pincodeList.map((option) => (
                <Option key={option.id} value={option.id}>
                  {option.unit_of_measurement}
                </Option>
              ))}
            </Select>
          );
        },
      },
    ];

    const theadColumns = <Table columns={subCategoryColumns} />;

    return (
      <>
        <Collapse defaultActiveKey={["4"]} className="collapsescrl">
          <Panel header={theadColumns} key="4">
            <Table
              key={subCategory}
              columns={subCategoryColumns}
              dataSource={subCategoryItems}
              pagination={false}
            />
          </Panel>
        </Collapse>
      </>
    );
  });


  const handleSubmit = async () => {

    try {
      setBtnLoading(true);

      let response;
      
      if (!prId) {
        const payload1 = {
          company: CompanyID,
          category_tree: 1,
          total_amount: overallTotal.toFixed(0),
          city_wise_pr: state.city_wise_pr.map((city) => {
            return {
              // city_id: city.id,
              // city_name: city.city_name,
              // city_total_quantity: city.total_quantity,
              site_wise_pr: city.site_wise_details.map((site) => {
                return {
                  site_name: site.site_id,
                  // site_name: site.site_name,
                  // site_total_quantity: site.site_total_quantity,
                  pr_material_details: site.material_wise_details.map((detail) => {
                    return {
                      material_type_by_company: detail.material_type_id,
                      total_quantity: detail.material_type_quantity,
                      total_quantity_by_kg: detail.material_total_quantity_by_kg,
                      unit_of_measurement: detail.material_type_uom,
                      remark: detail.material_remark,
                    };
                  }),
                };
              }),
            };
          }),
        };
        response = await postRequest("purchase-requisition/", payload1);
      }
      else {
        const payload2 = {
          company: CompanyID,
          category_tree: 1,
          total_amount: overallTotal,
          city_wise_pr: state.city_wise_pr.map((city) => {
            return {
              site_wise_pr: city.site_wise_pr.map((site) => {
                return {
                  site_name: site.pr_site_id,
                  site_total_quantity: site.site_total_quantity,
                  pr_material_details: site.pr_material_details.map((detail) => {
                    return {
                      material_type_by_company: detail.pr_material_type_id,
                      total_quantity: detail.pr_material_type_quantity,
                      unit_of_measurement: detail.pr_material_type_uom_name,
                      remark: detail.material_remark,
                    };
                  }),
                };
              }),
            };
          }),
        };
        response = await postRequest("purchase-requisition/", payload2);
      }

      if (response.data.success) {
        // SuccessNotificationMsg(t("purchase_requisition_added_successfully"));
        SuccessNotificationMsg(response.data.message);
        navigate("/purchase-requisition-history");
        setBtnLoading(false);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };

  const handleDraft = async () => {
    try {
      setBtnLoading2(true);
      let response;
      if (!prId) {
        const payload1 = {
          company: CompanyID,
          category_tree: 1,
          total_amount: overallTotal,
          city_wise_pr: state.city_wise_pr.map((city) => {
            return {
              site_wise_pr: city.site_wise_details.map((site) => {
                return {
                  site_name: site.site_id,
                  site_total_quantity: site.site_total_quantity,
                  pr_material_details: site.material_wise_details.map((detail) => {
                    return {
                      material_type_by_company: detail.material_type_id,
                      total_quantity: detail.material_type_quantity,
                      unit_of_measurement: detail.material_type_uom,
                    };
                  }),
                };
              }),
            };
          }),
        };

        response = await postRequest(
          "purchase-requisition/draft-purchase-requisition/",
          payload1
        );
      }
      else {
        const payload2 = {
          company: CompanyID,
          category_tree: 1,
          total_amount: overallTotal,
          city_wise_pr: state.city_wise_pr.map((city) => {
            return {
              site_wise_pr: city.site_wise_pr.map((site) => {
                return {
                  site_name: site.pr_site_id,
                  site_total_quantity: site.site_total_quantity,
                  pr_material_details: site.pr_material_details.map((detail) => {
                    return {
                      material_type_by_company: detail.pr_material_type_id,
                      total_quantity: detail.pr_material_type_quantity,
                      unit_of_measurement: detail.pr_material_type_uom_name,
                    };
                  }),
                };
              }),
            };
          }),
        };
        response = await postRequest(
          "purchase-requisition/draft-purchase-requisition/",
          payload2
        );
      }

      // }

      if (response.data.success) {
        SuccessNotificationMsg(
          CompanyID === null
            ? t("purchase_requisition_draft_successfully")
            : t("purchase_requisition_draft_updated_successfully")
        );

        setState(initialState);
        navigate("/purchase-requisition-history");
        setBtnLoading2(false);
      }
    } catch (error) {
      setBtnLoading2(false);
    }
  };

  const handleDisable = () => {
    const { purchase_requisition_details } = state;

    for (let detail of purchase_requisition_details) {
      for (let site of detail.site_wise) {
        if (site.quantity === null) {
          return true;
        }
      }
    }
    return false;
  };

  useEffect(() => {
    const { city_wise_pr } = state;
  
    if (Array.isArray(city_wise_pr)) {
      let shouldEnable = true;
  
      for (let detail of city_wise_pr) {
        for (let site of detail.site_wise_details) {
          for (let material of site.material_wise_details) {
            if (!material.material_type_quantity || material.material_type_quantity <= 0) {
              shouldEnable = false;
              break;
            }
          }
          if (!shouldEnable) break;
        }
        if (!shouldEnable) break;
      }
  
      setDisabled(!shouldEnable); 
    }
  }, [state.city_wise_pr]);

  const handleOptionChange = (e) => {
    const value = e.target.value;
    setView(value);
    setViewOption((prevState) => ({
      ...prevState,
      pr_view: value,
    }));
  };
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Purchase Requisition (PR) - Cement & RMC</h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Cement & RMC</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <section className="grid-sec mt-5">
        <div className="PR-body">
          <Spin spinning={apiLoading}>
            <Form ref={formRef}>
              <Row>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    className="radioitem"
                    name="pr_view"
                    initialValue={view}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Radio.Group
                      onChange={handleOptionChange}
                      value={view}
                    >
                      <Radio value="City Wise">City/Site Wise</Radio>
                      <Radio value="Material Wise">Material wise </Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>



            </Form>
          </Spin>
          {
            view === "City Wise" ? (
              <>
                <Collapse defaultActiveKey={["1"]}>
                  <Panel header={theadPR} key="1">
                    <Table
                      columns={columns}
                      dataSource={tableData}
                      pagination={false}
                    />
                  </Panel>

                  {/*<h3*/}
                    {/*style={{*/}
                      {/*backgroundColor: "#F8F8F8",*/}
                      {/*padding: "5px 20px",*/}
                      {/*borderRadius: "00px",*/}
                      {/*margin: "10px 0",*/}
                    {/*}}*/}
                  {/*>*/}
                    {/*{t("WBS")}*/}
                  {/*</h3>*/}

                  {/*<Panel header={theadWbsBudget} key="4">*/}
                    {/*<Table*/}
                      {/*columns={wbsBudget}*/}
                      {/*dataSource={stateWBS}*/}
                      {/*pagination={false}*/}
                    {/*/>*/}
                  {/*</Panel>*/}
                </Collapse>
                <div className="btnwrp" style={{ paddingTop: "16px" }}>
                  <ButtonField
                    className="CancelGradiantBtn"
                    type="primary"
                    htmlType="Cancel"
                    label="Cancel"
                    onClick={() => navigate("/dashboard")}


                  />
                  <ButtonField
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="submit"
                    label="Send PR for Approval"
                    loading={btnLoading}
                    onClick={handleSubmit}
                    disabled={disabled}
                  />
                </div>
              </>
            ) : (
              <PurchaseRequisitionSites userSelectedSiteList={userSelectedSiteList}/>
            )
          }
          <Modal
              className="ModelPopupSecDemo"
              title={t("site_selection")}
              open={siteModal}
              onOk={handleOk}
              onCancel={handleCancel}
              footer={[]}
              closable={false}
              keyboard={false}
              wrapClassName="modal-wrapper"
              loading={apiLoading}
              style={{ maxWidth: "250px", width: "100%" }} 
          >
              <SiteSelectionModal siteList={siteName} reload={reload} handleSave={handleSave} handleCancel={handleCancel} apiLoading={apiLoading}/>
          </Modal>
        </div>
      </section>
    </>
  );
};
export default NewPR;
